import { ApplicationStep } from '@payright/types-bnpl-checkout-api';
import { useHistory } from 'react-router-dom';
import { getStepRoute } from '../applicationStep';
import { ROUTES } from '../../routes';

export const useAppStepNavigation = () => {
  const history = useHistory();

  const goToStep = (step: ApplicationStep) => {
    const route = getStepRoute(step);
    if (route && route !== history.location.pathname) {
      history.push(`${route}${history.location.search}`);
    }
  };

  const goToErrorPage = (message: string) => {
    const currentParams = new URLSearchParams(history.location.search);
    currentParams.set('message', message);
    history.push(`${ROUTES.ERROR}?${currentParams.toString()}`);
  };

  return {
    goToStep,
    goToErrorPage,
  };
};
